import { render } from "./letter-forward-step5.vue?vue&type=template&id=db4e1ed2"
import script from "./letter-forward-step5.vue?vue&type=script&lang=js"
export * from "./letter-forward-step5.vue?vue&type=script&lang=js"

import "./letter-forward-step5.vue?vue&type=style&index=0&id=db4e1ed2&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__